<template>
  <sea-page
    class="mt-3"
    title="Dati dipendente"
    :header="'Dati del lavoratore ' + myData.cognome + ' ' + myData.nome"
    showCompanyHeader
    back
  >
    <sea-page-content toolbar hideRapidSearch>
      <employee-profile
        :fetchData="fetch"
        :reset="reset"
        :data="myData"
      ></employee-profile>
    </sea-page-content>
  </sea-page>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import EmployeeProfile from "@/components/EmployeeProfile.vue";
import SeaPageContent from "@/components/SeaPageContent.vue";

export default {
  components: { EmployeeProfile, SeaPageContent },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchMyData({ codFiscale: to.query.cf, idCompany: to.query.id });
    });
  },
  methods: {
    ...mapActions({
      fetchMyData: "widget/fetchEmployeeData",
      reset: "widget/resetEmployeeData",
    }),
    fetch() {},
  },
  computed: {
    ...mapGetters({
      myData: "widget/employeeData",
    }),
  },
};
</script>

<style>
</style>
